<div
  class="footer-container"
  #footerContainer
  [ngClass]="menu | method: 'getFooterWrapperClass'"
  [ngStyle]="{
    color: menu?.hydratedTheme?.themeFeatures?.footerTextColor ? menu?.menuOptions?.footerTextColor : ''
  }"></div>
